import { Component, ComponentRef, Input, OnInit, Type, ViewChild, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { ExDashboardService } from '../../ex-dashboard.service';
import { Dashboard } from '../../models/Dashboard';
import { DashboardComponent } from '../../models/DashboardComponent';
import { DataSheet } from '../../models/DataSheet';
import { ComponentService } from '../../services/component.service';
import { ExComponentHost } from './ex-component-resolver.directive';
import * as _ from 'lodash-es';
import { StrategyService } from '../../services/strategy.service';
import { DashboardComponentInput } from '../../models/DashboardComponentInput';
import { WorkspaceService } from 'projects/gtw-elements/src/app/workspace/workspace.service';
import { GridEventService } from '../../../grid/services/grid-event.service';
import { Constants } from '../../global-defaults/Constants';
import { ExDashboardEventService } from '../../services/event.service';
import { Subscription } from 'rxjs';

import { safeJsonInput } from '../../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-ex-component-resolver',
    templateUrl: './ex-component-resolver.component.html',
    styleUrls: ['./ex-component-resolver.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ExComponentResolverComponent implements OnInit {

  @Input()
  options!: DashboardComponent;

  @Input()
  hideLoader: boolean = false;

  jsonValidString: string = '';
  // options: any;
  sheet!: DataSheet;
  loading: boolean = false;
  componentMessage: string = '';
  componentMessages: string[] = [];
  dashboard!: Dashboard;
  component!: Type<any>;
  activeScreen: any; //use a type
  filterParams: any; //use a type

  /**
   * Reference to the `sheet.data` array we last mounted a component for.
   * Used by `renderComponent()` to short-circuit duplicate render passes
   * triggered by repeated `sheet-<name>:loaded` broadcasts (the dashboard
   * pipeline can fire `loadSheets()` more than once per mount when host
   * inputs re-bind, which doubled every chart mount and made some tiles
   * race their own teardown). Cleared when forced re-renders happen via
   * `componentReloaded` / `sheetFiltered` so legitimate refreshes still
   * go through.
   */
  private lastRenderedDataRef: any = null;

  @ViewChild(ExComponentHost, { static: true }) exCompHost!: ExComponentHost;
  componentEventListener!: Subscription;
  sheetFilteredEventListener!: Subscription;
  sheetLoadedEventListener!: Subscription;
  sheetLoadingEventListener!: Subscription;
  sheetErrorEventListener!: Subscription;

  constructor(private componentService: ComponentService,
    private dashboardService: ExDashboardService,
    private strategyService: StrategyService,
    private workspaceService: WorkspaceService,
    private eventService: ExDashboardEventService) {
    this.activeScreen = this.workspaceService.workspaceFactory.activeScreen;
  }

  ngOnInit(): void {
    if (this.options && this.options.extraOptions) {
      if (_.isString(this.options.extraOptions)) {
        try {
          this.options.extraOptions = safeJsonInput<any>(this.options.extraOptions, null, 'ex-component-resolver.parse1');
        } catch (e) {
          try {
            // fallback: some API responses use single quotes or JS object notation
            this.options.extraOptions = JSON.parse(this.options.extraOptions.replace(/'/g, '"'));
          } catch (e2) {
            console.warn('[ExComponentResolver] Could not parse extraOptions:', e2);
          }
        }
      }
    }

    // this.options = this.config;
    console.log("component init: " + this.options.component_type);

    this.initEvents();

    this.initSheet();

    if (this.sheet) {
      if (this.sheet.isLoaded) {
        this.renderComponent(this.sheet);
      } else {
        this.loading = true;
      }
    }
  }

  initEvents() {
    console.log("component event registered: " + this.options.component_type);

    // The payload was historically broadcast as `true` from ex-chart's
    // context-menu handler (causing newComponentObj and doUpdate to both
    // resolve as undefined, silently preventing re-render). It is now
    // broadcast as { newComponentObj, doUpdate } from the fixed handler.
    // Accept both shapes so older callers don't silently break.
    this.componentEventListener = this.eventService.on('component-' + this.options.component_id + ':reload').subscribe((event: any) => {
      if (event && typeof event === 'object' && 'newComponentObj' in event) {
        this.componentReloaded(event.newComponentObj, event.doUpdate);
      } else {
        // Legacy boolean broadcast — treat as "reload with current options".
        this.componentReloaded(this.options, true);
      }
    });
    this.sheetFilteredEventListener = this.eventService.on('sheet:filtered').subscribe((sheetName: string) => this.sheetFiltered(sheetName));
    this.sheetLoadedEventListener = this.eventService.on('sheet-' + this.options.srcSheet + ':loaded').subscribe(() => this.sheetLoaded());
    this.sheetLoadingEventListener = this.eventService.on('sheet-' + this.options.srcSheet + ':loading').subscribe(() => this.sheetLoading());
    this.sheetErrorEventListener = this.eventService.on('sheet-' + this.options.srcSheet + ':error').subscribe((err: any) => this.sheetError(err));
  }

  initSheet() {
    if (this.options.previewMode) {
      this.sheet = { ...this.options.previewSheetData };
    }
    else {

      // if (!this.hideLoader)
      //     $(element).append($compile('<div modal-loader loading="this.loading"></div>')(scope));

      this.dashboard = this.dashboardService.getDashboardById(this.options.dashboard_id);
      // var this.componentMessage = $(element).find('.component-error-message');


      if (this.dashboard) {
        if (this.dashboard.dataSheets.length === 0) {
          const viewContainerRef = this.exCompHost.viewContainerRef;
          viewContainerRef.clear();
          this.loading = false;
          this.LoadComponent(viewContainerRef);
          return;
        }
        this.sheet = {
          ...this.dashboard.dataSheets.find((item) => {
            return item.name === this.options.srcSheet;
          })!
        };

        if (!this.options.filterable) {
          this.sheet.data = this.sheet.safeCopyArr;
        }
      }

    }
  }

  renderComponent(sheet: DataSheet) {
    this.loading = sheet.isLoading;
    console.log("component rendering: " + this.options.component_type);
    if (this.loading) {
      return;
    }

    // Idempotency guard: dashboards (esp. the e-file dashboard) can call
    // `loadSheets()` more than once per mount when host inputs rebind,
    // and `Dashboard.loadSheetObservable` re-broadcasts `sheet-<name>:loaded`
    // on each completion. Without this guard every subscriber re-runs the
    // render path, tearing down the just-mounted Highcharts component via
    // `viewContainerRef.clear()` and recreating it — that is the visible
    // "two chart mounts, one paints, the other races" symptom in the
    // console trace (12 `rendering` logs for 6 components, 5 `stacklabels`
    // for 6 chart tiles). Comparing the underlying `sheet.data` reference
    // skips the duplicate while still allowing legitimate reloads (new
    // submission HTTP returns a fresh array reference) and explicit force
    // paths (`componentReloaded` / `sheetFiltered` clear the ref first).
    const incomingDataRef = sheet.data;
    if (
      this.component &&
      this.lastRenderedDataRef === incomingDataRef &&
      !this.componentMessage &&
      (!this.componentMessages || this.componentMessages.length === 0)
    ) {
      return;
    }
    this.lastRenderedDataRef = incomingDataRef;

    // var this.componentMessage = $(element).find('.component-error-message');

    const viewContainerRef = this.exCompHost.viewContainerRef;
    viewContainerRef.clear();

    if (this.dashboard) {
      const colSearch = Array.isArray(this.dashboard.tableState?.colSearch)
        ? this.dashboard.tableState.colSearch
        : [];
      // Native filter: lodash-es `_.chain(...).filter` is not a function in
      // this bundle, which threw while the e-file dashboard rendered tiles.
      const filtersApplied = colSearch.filter((item) => {
        const sheets = Array.isArray(item.sheet)
          ? item.sheet
          : (item.sheet != null && item.sheet !== '' ? [String(item.sheet)] : []);
        const val = item.value;
        const hasValue = Array.isArray(val)
          ? val.length > 0
          : (val != null && String(val).length > 0);
        return sheets.includes(this.options.srcSheet) && hasValue;
      }).map((item) => item.name).join(',');

      if (this.options.title) {
        const safeLen = Array.isArray(sheet.safeCopyArr) ? sheet.safeCopyArr.length : 0;
        const dataLen = Array.isArray(sheet.data) ? sheet.data.length : 0;
        if (safeLen !== dataLen) {
          if (filtersApplied) {
            this.options.title = this.options.title.split('(filtered')[0];
            this.options.title = this.options.title + ' (filtered by ' + filtersApplied + ')';
          }
        } else {
          this.options.title = this.options.title.split('(filtered')[0];
        }
      }
    }



    if (!this.options.component_type) {
      this.loading = false;
      this.componentMessage = 'Please select component type.';
      // $(element).append('<h4 class="component-error-message" >Please select component type.</h4>');
      return;
    }



    this.componentMessage = '';



    // Components that manage their own data don't need sheet data or strategy
    const selfManagedComponents = ['projectReview'];
    if (selfManagedComponents.includes(this.options.component_type)) {
      this.LoadComponent(viewContainerRef);
      return;
    }

    if (!Array.isArray(sheet.data)) {
      this.loading = false;
      this.componentMessage = 'Error occured while fetching data';

      // $(element).append('<h4 class="component-error-message" >Error occured while fetching data</h4>');
      return;
    }

    if (this.options && this.options.extraOptions && _.isString(this.options.extraOptions)) {
      try {
        this.options.extraOptions = safeJsonInput<any>(this.options.extraOptions, null, 'ex-component-resolver.parse2');
      } catch (e) {
        try {
          this.options.extraOptions = JSON.parse(this.options.extraOptions.replace(/'/g, '"'));
        } catch (e2) {
          console.warn('[ExComponentResolver] Could not parse extraOptions in render:', e2);
        }
      }
    }

    this.checkFilterParams(sheet);
    this.defaultComponentFilter(sheet);


    if ((!sheet.data || sheet.data.length === 0) && !this.loading) {
      this.loading = false;
      this.componentMessage = 'No Data Available';
      // $(element).append('<h4 class="component-error-message" >No Data Available</h4>');
      return;
    }



    if (!this.options.strategy && this.options.component_type !== 'combinationChart') {
      this.componentMessage = 'Please select Strategy Type.';
      // $(element).append('<h4 class="component-error-message" >Please select Strategy Type.</h4>');
      return;
    }
    if (this.options.component_type !== 'combinationChart') {
      console.log('[ExResolver] runStrategy →', {
        strategy: this.options.strategy,
        rows: sheet.data?.length || 0,
        firstRowCols: sheet.data?.[0] ? Object.keys(sheet.data[0]) : [],
        strategySettings: _.cloneDeep(this.options.extraOptions?.strategySettings),
        previewMode: this.options.previewMode,
      });
      const componentData = this.strategyService.runStrategy(this.options.strategy, sheet.data, this.options.extraOptions.strategySettings);
      if (componentData.errorMsgs && componentData.errorMsgs.length > 0) {
        console.warn('[ExResolver] strategy returned errors:', componentData.errorMsgs);
        this.componentMessages = (componentData.errorMsgs as string[]);
        this.loading = false;
        return;
      }

      this.options.data = componentData;
    }


    this.LoadComponent(viewContainerRef);
    // element.append($compile('<div class="component-container">' + template + '</div>')(scope));
  }

  private LoadComponent(viewContainerRef: ViewContainerRef) {
    this.component = this.componentService.getComponent(this.options.component_type)!;

    if (this.component) {
      this.loading = false;

      const componentRef = viewContainerRef.createComponent(this.component);

      componentRef.instance.options = this.options;
      // No post-mount resize nudge: chart-type switches now go through
      // `component-<id>:chartType` (handled in-place via `chart.update`),
      // so this code path only runs for genuine reloads where each chart's
      // own ResizeObserver / IntersectionObserver / render() reflow chain
      // already covers initial layout.
    } else {
      this.componentMessage = 'No component available of this type';
    }
  }

  checkFilterParams(sheet: DataSheet) {
    this.filterParams = (this.activeScreen.filters) ? this.activeScreen.filters.getFilterParams() : {};
    console.log("Filter Params", this.filterParams);

    this.options.extraOptions.componentSettings = this.options.extraOptions.componentSettings || {}
    if (this.options.extraOptions.strategySettings && this.options.extraOptions.strategySettings.default_filter_by && _.keys(this.filterParams).includes(this.options.extraOptions.strategySettings.default_filter_by.toLowerCase())) {



      // this.config.extraOptions.strategySettings.default_filter_by = 'TAX_YEAR'
      this.options.extraOptions.strategySettings.default_filter_value = this.filterParams[this.options.extraOptions.strategySettings.default_filter_by.toLowerCase()]
    }
  }
  defaultComponentFilter(sheet: DataSheet) {

    if (this.options.extraOptions && this.options.extraOptions.strategySettings && this.options.extraOptions.strategySettings.is_default_filter && this.options.extraOptions.componentSettings && this.options.extraOptions.strategySettings.default_filter_by) {
      if (sheet && Array.isArray(sheet.data)) {
        const groupKey = this.options.extraOptions.strategySettings.default_filter_by;
        const groups = new Map<string, any[]>();
        for (const row of sheet.data) {
          const name = String(row?.[groupKey]);
          const bucket = groups.get(name);
          if (bucket) {
            bucket.push(row);
          } else {
            groups.set(name, [row]);
          }
        }

        if (this.options.extraOptions.strategySettings.default_filter_value) {
          sheet.data = groups.get(String(this.options.extraOptions.strategySettings.default_filter_value)) ?? [];
          sheet.safeCopyArr = [...sheet.data];
        } else {
          sheet.data = groups.values().next().value ?? [];
        }
      }
    }
  }

  sheetLoaded() {
    const dashboard = this.dashboardService.getDashboardById(this.options.dashboard_id);
    if (!dashboard) {
      // Dashboard was replaced in the pool between subscribe and event — the
      // next real broadcast will arrive shortly, ignore this stale replay.
      return;
    }
    const liveSheet = dashboard.dataSheets.find((item) => item.name === this.options.srcSheet);
    if (!liveSheet) {
      return;
    }
    // Guard against stale replay while HTTP is in flight: `sheetLoaded` may
    // run from a cached `:loaded` tick before `loadSheets` finishes updating
    // this sheet row; skip until the live sheet is actually marked loaded.
    if (!liveSheet.isLoaded) {
      // Sheet HTTP is still in flight — the real `:loaded` event will fire
      // and call sheetLoaded() again once the HTTP finishes.
      return;
    }
    const sheet: DataSheet = { ...liveSheet };
    console.log("component sheet loaded: " + this.options.component_type);
    this.renderComponent(sheet);
  }

  sheetLoading() {
    const viewContainerRef = this.exCompHost.viewContainerRef;
    viewContainerRef.clear();

    this.componentMessage = '';
    this.loading = true;

  }

  sheetError(_err: any) {
    const viewContainerRef = this.exCompHost.viewContainerRef;
    viewContainerRef.clear();
    this.loading = false;
    this.componentMessage = 'Error occured while fetching data';
  }

  sheetFiltered(sheetName: string) {
    if (this.options.srcSheet !== sheetName || !this.options.filterable) {
      return;
    }
    if (this.dashboard) {
      this.sheet = {
        ...this.dashboard.dataSheets.find((item) => {
          return item.name === sheetName;
        })!
      };

      if (this.sheet) {
        // element[0].childNodes[element[0].childNodes.length - 1].remove();//remove old component
        // Filter pipeline mutates `sheet.data` in place under the same
        // array reference; clear the idempotency record so the render
        // gate still allows the refreshed view through.
        this.lastRenderedDataRef = null;
        this.renderComponent(this.sheet);
      }
    }
    else {
      if (this.options.previewSheetData) {
        // element[0].childNodes[element[0].childNodes.length - 1].remove();//remove old component
        this.lastRenderedDataRef = null;
        this.renderComponent(this.options.previewSheetData);
      }
    }
  }

  componentReloaded(newComponentObj: DashboardComponent, doUpdate: boolean) {
    // Treat missing `doUpdate` as true so older callers / partial payloads still reload.
    const allowUpdate = doUpdate !== false;
    if (this.dashboard && allowUpdate) {
      this.options = newComponentObj || this.options;
      const sheetData = this.dashboard.dataSheets.find((item) => {
        return item.name === this.options.srcSheet;
      });
      if (sheetData) {
        // Force a render — the user explicitly asked for a reload (chart
        // type switch, options change). Bypass the idempotency guard so
        // the new component_type / extraOptions take effect even when
        // `sheet.data` is the same array we already rendered.
        this.lastRenderedDataRef = null;
        this.renderComponent(sheetData);
      }
    } else if (this.options.previewSheetData) {
      this.lastRenderedDataRef = null;
      this.renderComponent(this.options.previewSheetData);
    }
  }

  typeOf(obj: any) { return typeof obj }

  ngOnDestroy() {
    // this.eventService.off('component-' + this.options.component_id + ':reload',this.componentEventListener);
    // this.eventService.off('sheet:filtered',this.sheetFilteredEventListener);
    // this.eventService.off('sheet-' + this.options.srcSheet + ':loaded',this.sheetLoadedEventListener);
    // this.eventService.off('sheet-' + this.options.srcSheet + ':loading',this.sheetLoadingEventListener);
    this.componentEventListener.unsubscribe();
    this.sheetFilteredEventListener.unsubscribe();
    this.sheetLoadedEventListener.unsubscribe();
    this.sheetLoadingEventListener.unsubscribe();
    this.sheetErrorEventListener.unsubscribe();
  }

}
